export default function TotWorkCard({ work }: any) {
  return (
    <div className='flex flex-col items-center border-none w-[100%] h-132 md:h-[330px] rounded-[5px] md:rounded-[12px] mt-17 md:mt-[42px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)] px-30 md:px-[75px]'>
      <p className='w-[100%] flex text-15 md:text-37 font-preBold leading-18 md:leading-[45px] mt-14 md:mt-[35px] truncate'>{work.name}</p>
      <div className='w-[100%] flex justify-between items-center mt-15 md:mt-[37px]'>
        <p className='text-14 leading-17 md:text-35 md:leading-[42px]'>일반 작업</p>
        <p className='text-15 md:text-37 font-preBold text-point leading-18 md:leading-[45px]'>{work.totWrkCnt - work.dngrWrkCnt}
          <span className='ml-3 md:ml-[7px] font-medium text-txtBlack'>건</span>
        </p>
      </div>
      <div className='w-[100%] flex justify-between items-center mt-14 md:mt-[35px]'>
        <p className='text-14 leading-17 md:text-35 md:leading-[42px]'>위험 작업</p>
        <p className='text-15 md:text-37 font-preBold text-point leading-18 md:leading-[45px]'>{work.dngrWrkCnt}
          <span className='ml-3 md:ml-[7px] font-medium text-txtBlack'>건</span>
        </p>
      </div>
    </div>
  );
}

